import { FixedAssetValueChange } from '@modeso/types__aumico-lib-annualreport-be';

export interface IFasAccountValue {
    accountNumber: string;
    accountName: string;
    costs: FixedAssetValueChange;
    depreciation: FixedAssetValueChange;
    valueAppreciation: FixedAssetValueChange;
}
